import animateValue, { updateHeight } from "../utils/animateValue";
import { mediaMin } from "../utils/breakpoints";
import { disableVideo, enableVideo } from "../utils/video";
import { debounce } from "../utils/performance";

export default function(el) {
    const items = el.querySelectorAll(".vt__item");
    const tabs = el.querySelector(".vt__tabs");
    let tabsHeight = tabs && tabs.offsetHeight;
    let animationDuration = getComputedStyle(el).getPropertyValue("--vt-a-duration");
    let activeItem = null;

    animationDuration = animationDuration ? parseInt(animationDuration.replace(/[^0-9]/g, ""), 10) : null;

    const toggleItem = (index) => {
        if (
            !mediaMin("md") ||
            !items[index] ||
            (items[index] && items[index].classList.contains("vt__item--active"))
        )
            return;

        if (items[activeItem]) {
            items[activeItem].classList.remove("vt__item--active");
            adjustElementsHeight(items[activeItem], false);
            disableVideo(items[activeItem]);
        }

        items[index].classList.add("vt__item--active");
        enableVideo(items[index]);
        adjustElementsHeight(items[index], true);
        activeItem = index;
    };

    const adjustElementsHeight = (item, active) => {
        const toggle = item.querySelector(".vt__toggle-bottom");
        const media = item.querySelector(".hvt__media");

        if (toggle)
            animateValue(toggle, updateHeight, toggle.offsetHeight, active ? toggle.scrollHeight : 0, 300);

        if (!active || !media || !tabsHeight || media.offsetHeight === tabsHeight) return;

        animateValue(
            tabs,
            updateHeight,
            tabs.offsetHeight,
            media.offsetHeight > tabsHeight ? media.offsetHeight : tabsHeight,
            300
        );
    };

    const handleTransitionEnd = (index, e) => {
        if (
            !mediaMin("md") ||
            e.propertyName !== "transform" ||
            !e.target.classList.contains("vt__indicator") ||
            e.elapsedTime !== animationDuration
        )
            return;

        const x = index + 1;
        const realIndex = x > items.length - 1 ? 0 : x;
        toggleItem(realIndex);
    };

    const setClickEventListeners = () =>
        items.forEach((item, index) => {
            const toggle = item.querySelector(".vt__toggle");

            if (toggle) toggle.addEventListener("click", toggleItem.bind(null, index));

            if (animationDuration)
                item.addEventListener(
                    "transitionend",
                    handleTransitionEnd.bind(null, index >= items.length ? 0 : index)
                );
        });

    const handleResizeEvent = debounce(() => {
        if (!mediaMin("md")) {
            tabs && tabs.getAttribute("style") && tabs.removeAttribute("style");
            return;
        }

        tabsHeight = tabs && tabs.offsetHeight;
        if (!activeItem) toggleItem(0);
    }, 150);

    if (items.length === 0) return;

    window.addEventListener("resize", handleResizeEvent);
    setClickEventListeners();
    toggleItem(0);
}
